import { StaticPage } from '@dreamstack/accentro-contentful/src/components/StaticPage'
import { getStaticPagePaths } from '@dreamstack/accentro-contentful/src/contentful/staticPages/getStaticPagePaths'
import { getStaticPageProps } from '@dreamstack/accentro-contentful/src/contentful/staticPages/getStaticPageProps'
import { useParams } from '@dreamstack/feature-components/src/hooks/useParams'
import { getStaticPathsPlus } from '../lib/getStaticPathsPlus'
import { getStaticPropsPlus } from '../lib/getStaticPropsPlus'

// Keep in sync with generated slugs from newsTypeUrls.static.ts
// (including transformation by `getCityUrlPart`)
const PILLARPAGES_NOT_TO_BUILD = [
  'wissen/immobilienkauf',
  'wissen/aktuelles',
  'wissen/kapitalanlagen-und-investments',
  'wissen/finanzierung',
  'wissen/wohntrends',
  'wissen/staedte-und-quartiere',
  'wissen/fuer-eigentuemer',
  'knowledge/news',
  'knowledge/real-estate-purchase',
  'knowledge/capital-investments',
  'knowledge/financing',
  'knowledge/home-and-living',
  'knowledge/cities-and-neighbourhoods',
  'knowledge/for-owners',
]

export const SLUGS_NOT_TO_BUILD = [
  'index',
  'news',
  '404',
  'projects',
  'projekte',
  'properties',
  'immobilien',
  'immoscout24',
  process.env.NEXT_PUBLIC_NEWS_BASE_URL_DE!,
  process.env.NEXT_PUBLIC_NEWS_BASE_URL_EN!,
  ...PILLARPAGES_NOT_TO_BUILD,
]

export default function StaticPagePage() {
  const { slug } = useParams()
  if (slug === '__nextjs_original-stack-frame') {
    // console.log('fake rendering __nextjs_original-stack-frame')
    return null
  }
  return <StaticPage slug={slug} />
}

export const getStaticProps = getStaticPropsPlus({
  // queries: defaultQueries,
  getProps: getStaticPageProps,
})

export const getStaticPaths = getStaticPathsPlus({
  // fallback: false,
  ...getStaticPagePaths({
    slugsNotToBuild: SLUGS_NOT_TO_BUILD,
  }),
})
